module.exports = __webpack_public_path__ + "static/media/CommunityChange.e93c3fef.svg";